/**
 * Centralized ref-master category key constants.
 *
 * These are the `category` values sent to the ref_master API.
 * Dynamic keys (TRUCK_MODEL_*, TRUCK_ENGINE_MODEL_*, TRAILER_MODEL_*,
 * TRUCK_BODY_*_*, TRAILER_BODY_*_*) are constructed at runtime in
 * refCategories.ts and are intentionally NOT listed here.
 */
export const REF_KEYS = {
  // ── Basic Information ────────────────────────────────────────────────────
  TYPE_OF_LOSS:  'type_of_loss',
  VEHICLE_TYPE:  'vehicle_type',
  COUNTRY_STATE: 'country_state',

  // ── Truck / Tractor — Standard Equipment ────────────────────────────────
  TRUCK_USE:               'TRUCK_USE',
  TRUCK_MAKE:              'TRUCK_MAKE',
  TRUCK_ENGINE_MFG:        'TRUCK_ENGINE_MFG',
  TRUCK_ENGINE_HP:         'TRUCK_ENGINE_HP',
  TRUCK_TRANS_MFG:         'TRUCK_TRANS_MFG',
  TRUCK_FRONT_AXLE_RATING: 'TRUCK_FRONT_AXLE_RATING',
  TRUCK_REAR_AXLE_RATING:  'TRUCK_REAR_AXLE_RATING',
  TRUCK_GVWR:              'TRUCK_GVWR',
  TRUCK_STYLE:             'TRUCK_STYLE',
  TRUCK_TYPE:              'TRUCK_TYPE',

  // ── Truck / Tractor — Additional Options ────────────────────────────────
  TRUCK_SLEEPER_SIZE:       'TRUCK_SLEEPER_SIZE',
  TRUCK_COE_SIZE:           'TRUCK_COE_SIZE',
  TRUCK_APU:                'TRUCK_APU',
  TRUCK_TRIM_LEVEL:         'TRUCK_TRIM_LEVEL',
  TRUCK_WHEEL_TYPE:         'TRUCK_WHEEL_TYPE',
  TRUCK_TIRE_SIZE:          'TRUCK_TIRE_SIZE',
  TRUCK_SUSPENSION:         'TRUCK_SUSPENSION',
  TRUCK_LIFT_GATE_CAPACITY: 'TRUCK_LIFT_GATE_CAPACITY',
  TRUCk_FIFTH_WHEEL_TYPE:   'TRUCk_FIFTH_WHEEL_TYPE',
  TRUCK_HITCH_TYPE:         'TRUCK_HITCH_TYPE',

  // ── Truck / Tractor — Vehicle Condtions ────────────────────────────────
  TRUCK_VEHICLE_CONDITON: 'TRUCK_VEHICLE_CONDITON',

  // ── Trailer — Standard Equipment ────────────────────────────────────────
  TRAILER_MAKE:   'TRAILER_MAKE',
  TRAILER_TYPE:   'TRAILER_TYPE',
  TRAILER_EXTERIOR: 'TRAILER_EXTERIOR',
  TRAILER_LENGTH: 'TRAILER_LENGTH',

  // ── Trailer — Additional Options ────────────────────────────────────────
  TRAILER_HEIGHT:          'TRAILER_HEIGHT',
  TRAILER_WIDTH:           'TRAILER_WIDTH',
  TRAILER_SUSPENSION:      'TRAILER_SUSPENSION',
  TRAILER_GAWR:            'TRAILER_GAWR',
  TRAILER_INTERIOR_LINING: 'TRAILER_INTERIOR_LINING',
  TRAILER_REAR_DOOR_TYPE:  'TRAILER_REAR_DOOR_TYPE',
  TRAILER_OS_WHEEL_TYPE:   'TRAILER_WHEEL_TYPE',
  TRAILER_IS_WHEEL_TYPE:   'TRAILER_WHEEL_TYPE',
  TRAILER_TIRE_SIZE:       'TRAILER_TIRE_SIZE',

  // ── Truck / Tractor — Vehicle Condtions ────────────────────────────────
  TRAILER_VEHICLE_CONDITON: 'TRAILER_VEHICLE_CONDITON',

  // ── Section Images ───────────────────────────────────────────────────────
  SECTION: 'sections',

  // ── Shared "Not in List" fallback for ref-backed dependent fields ─────────
  // Used when a parent dropdown (e.g. Make, Trans Mfg) is set to "Not in List" so
  // the child (e.g. Model, # of Speeds) can still resolve a real ref_master ID
  // instead of a hardcoded string. One shared sentinel row/category reused across
  // every ID-backed dependent field — there's nothing category-specific about a
  // "Not in List" label, so no separate row is needed per field.
  NOT_IN_LIST_MODEL: 'NOT_IN_LIST_MODEL',
} as const

/** Union type of every valid base ref-master category key. */
export type RefKey = typeof REF_KEYS[keyof typeof REF_KEYS]
